module.exports = __webpack_public_path__ + "dist/assets/redesign/ui/components/intro/img/intro-screen-9@2x__e1804fb251a70e45cdc4f375981f5ba7.png";